<template>
  <div class="notification is-danger is-light">
    <button class="delete" @click="onClosed"></button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FailureNotification',
  props: {
    label: String,
    onClosed: Function
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FailureNotification.vue